import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '@sm/store/toastSlice';

export function useClipboard() {
  const dispatch = useDispatch();

  const copyToClipboard = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      dispatch(showToast('success', 'Copied to clipboard!'));
    } catch (error) {
      dispatch(showToast('danger', 'Something went wrong!'));
    }
  }, [dispatch]);

  return copyToClipboard;
}
